module.exports = __webpack_public_path__ + "static/media/picto_noir.fc128f15.svg";